import Layout from '../../internal/Layout.vue'
import UsersPage from './Users/users.vue'
import UserProfile from './components/UserProfile/UserProfile.vue'

const UsersRoutes = {
  component: Layout,
  children: [
    {
      name: 'user',
      path: '/',
      component: UsersPage,
      meta: {
        module: 'users',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
    {
      name: 'userProfile',
      path: '/userProfile',
      component: UserProfile,
      meta: {
        module: 'users',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresSolicitor: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default UsersRoutes
